import React from 'react'
import { EventType } from '../../modules/notifications/enums/EventType'
import defaultIcon from '../../assets/notification-icons/default.svg'
import calendarIcon from '../../assets/notification-icons/calendar.svg'
import formIcon from '../../assets/notification-icons/form.svg'
import resourcesIcon from '../../assets/notification-icons/resources.svg'
import articleIcon from '../../assets/notification-icons/article.svg'
import trainingIcon from '../../assets/notification-icons/training.svg'
import styles from './NotificationItem.module.css'

interface NotificationIconProps {
  eventType: EventType
  className?: string
}

export const NotificationIcon = ({ eventType, className = '' }: NotificationIconProps) => {
  const getIconSrc = () => {
    switch (eventType) {
      case EventType.AppointmentCreated:
      case EventType.AppointmentUpdated:
      case EventType.AppointmentCancelled:
        return calendarIcon

      case EventType.FormSubmitted:
      case EventType.FormCompleted:
        return formIcon

      case EventType.ResourceShared:
      case EventType.ResourceUpdated:
        return resourcesIcon

      case EventType.ArticlePublished:
      case EventType.ArticleUpdated:
        return articleIcon

      case EventType.TrainingAssigned:
      case EventType.TrainingCompleted:
        return trainingIcon

      case EventType.CalendarEventCreated:
      case EventType.CalendarEventReminder:
        return calendarIcon

      default:
        return defaultIcon
    }
  }

  return (
    <img
      src={getIconSrc()}
      alt={`${eventType} icon`}
      className={`${styles.notificationIcon} ${className}`}
    />
  )
}
